import api from '../../api'
import _ from 'lodash'
import Constants from '../../constants'

const getDefaultState = () => {
  return {
    all: []
  }
}

const state = getDefaultState()

const getters = {
  isOn: (state) => (place) => {
    const index = state.all.findIndex(p => p.name === place.name && p.location.latitude === place.location.latitude && p.location.longitude === place.location.longitude)
    return index >=0 ? true : false
  },
  getFavorites: (state) => state.all,
  getFavoritedPlaces: (state, _getters, _rootState, rootGetters) => {
    const places = _.cloneDeep(rootGetters['places/getPlaces'])
    const favorites = state.all
    return places.filter(place => {
      return favorites.includes(place.id)
    })
  }
}

const actions = {
  fetchAll ({ rootGetters, commit }) {
    const token = rootGetters['user/getToken']

    return new Promise((resolve, reject) => {
      api.getFavorites(token)
        .then((favorites) => {
          if (favorites !== undefined) {
            commit('setFavorites', favorites)
          }
          resolve()
        })
        .catch(() => reject())
    })
  },
  create ({ rootGetters, state, commit }, place) {
    commit('push', place)
    const token = rootGetters['user/getToken']
    if (token) {
      return new Promise((resolve, reject) => {
        api.putFavorite(state.all, token)
          .then(() => {
            resolve()
          })
          .catch(() => reject())
      })
    }
  },
  delete ({ rootGetters, state, commit }, place) {
    commit('destroy', place)
    const token = rootGetters['user/getToken']
    if (token) {
      return new Promise((resolve, reject) => {
        api.putFavorite(state.all, token)
          .then(() => {
            resolve()
          })
          .catch(() => reject())
      })
    }
  },
  deleteIndex ({ rootGetters, state, commit }, index) {
    commit('destroyIndex', index)
    const token = rootGetters['user/getToken']
    if (token) {
      return new Promise((resolve, reject) => {
        api.putFavorite(state.all, token)
          .then(() => {
            resolve()
          })
          .catch(() => reject())
      })
    }
  },
  reset ({ commit }) {
    commit('resetState')
  }
}

const mutations = {
  setFavorites (state, favorites) {
    state.all = favorites
  },
  push (state, place) {
    const p = {
      id: place.id,
      name: place.name,
      location: place.location,
      isGooglePlace: place.isGooglePlace,
      isEkispertPlace: place.isEkispertPlace,
      isGeocode: place.isGeocode,
      type: place.type,
      genreIds: place.genreIds
    }
    state.all.unshift(p)
    if (state.all.length > Constants.MAX_FAVORITE_PLACE) {
      state.all.splice(Constants.MAX_FAVORITE_PLACE)
    }
  },
  destroy (state, place) {
    const index = state.all.findIndex(p => p.name === place.name && p.location.latitude === place.location.latitude && p.location.longitude === place.location.longitude)
    if (index > -1) { state.all.splice(index, 1) }
  },
  destroyIndex (state, index) {
    state.all.splice(index, 1)
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
